module.exports = __webpack_public_path__ + "media/T-360_Overview.4915a350.mp4";